export const NotificationEvents = {
  received: 'notification.received'
} as const;

export type NotificationEventType = (typeof NotificationEvents)[keyof typeof NotificationEvents];

export interface NotificationReceivedPayload {
  notificationId: string;
  header: string;
  body: string;
  data: string;
  createdAt: string;
  isRead: boolean;
  showToast?: boolean;
}

export const NOTIFICATION_EVENT_TYPES: readonly NotificationEventType[] = Object.values(NotificationEvents);
